/*eslint-disable */
// constants
import { REACTIVATION_TEMPLATE, EXCEL_ROW_OFFSET } from "./bulkUsersUpload.constants"

// helpers
import { isValidDomainName, isValidEmail, isValidName, 
  isValidPhoneNumber, isValidGroupId, isValidLocale,
  isValidSendActivationEmail, isValidCountry, isValidSecondaryEmail, isValidPreferredLanguage } from "../../../../helpers/validators"

// constant
import { DISABLED_BULK_FOR_TENANTS } from "../../createUser.constants";
import { isRestrictedTenant } from "../../../../helpers/users";

import i18next from 'i18next'

export const bytesToSize = (bytes) => {
  var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes == 0) return "n/a";
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  if (i == 0) return bytes + " " + sizes[i];
  return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
};

export const makeBulkUploadUsersDTO = file => {
  return {
    // targetApp: 'iga_admin',
    operation: 'upsert_users',
    file:file,
  }
}

const addNameFieldsToErrorFields = (user, errorFields) => {
  if(!isValidName(user.firstName)) {
    errorFields.push('firstName');
  }

  if(isRestrictedTenant() && !isValidName(user.lastName)) {
    errorFields.push('lastName');
  }  

}

const addEmailToErrorFields = (user, errorFields) => {
  if(!isValidEmail(user.email)) {
    errorFields.push('email');
  }
}

const addPhoneNumberToErrorFields = (user, errorFields) => {
  const phoneNumber = user.phone;
  if(phoneNumber && !isValidPhoneNumber(phoneNumber)) {
    errorFields.push('phone');
  }
}

const addLocaleToErrorFields = (user, errorFields) => {
  const locale = user.locale;
  if(locale && !isValidLocale(locale)) {
    errorFields.push('locale');
  }
}

const addCountryToErrorFields = (user, errorFields) => {
  const country = user.country;
  if(country && !isValidCountry(country)) {
    errorFields.push('country');
  }
}

const addDomainNameToErrorFields = (user, errorFields) => {
  const domainName = user.domainName;
  if(!isValidDomainName(domainName)) {
    errorFields.push('domainName');
  }
}

const addSendActivationEmailToErrorFields = (user, errorFields) => {
  const sendActivationEmail = user.sendActivationEmail;
  if(!isValidSendActivationEmail(sendActivationEmail)) {
    errorFields.push('sendActivationEmail');
  }
}

const addGroupIdsToErrorFields = (user, errorFields) => {
  const groupIds = user.groupIDs;
  if(groupIds) {
    const groupIdsArray = groupIds.split(',')
    groupIdsArray.forEach(groupId => {
      if(!isValidGroupId(groupId)) {
        errorFields.push('groupIDs');
      }
    })
  }
}

const addSecondaryEmailToErrorFields = (user, errorFields) => {
  if(!isValidSecondaryEmail(user.secondaryEmail)) {
    errorFields.push('secondaryEmail');
  }
}

const addPreferredLanguageErrorFields = (user, errorFields) => {
  if(!isValidPreferredLanguage(user.preferredLanguage)) {
    errorFields.push('preferredLanguage');
  }
}

const addValidationErrorsForBulkUploadUser = (user, validationErrors) => {
  const errorFields = []
  addNameFieldsToErrorFields(user, errorFields);
  addEmailToErrorFields(user, errorFields);
  addPhoneNumberToErrorFields(user, errorFields);
  addLocaleToErrorFields(user, errorFields);
  addCountryToErrorFields(user, errorFields);
  addGroupIdsToErrorFields(user, errorFields);
  addSecondaryEmailToErrorFields(user, errorFields);
  addPreferredLanguageErrorFields(user, errorFields);
  validationErrors.push(errorFields);
}

const addValidationErrorsForReactivateUser = (user, validationErrors) => {
  const errorFields = []
  addEmailToErrorFields(user, errorFields);
  addDomainNameToErrorFields(user, errorFields);
  validationErrors.push(errorFields);
}

export const getErrorsByColumnFields = (validationErrors=[]) => {
  const errorsByColumnFields = {};
  validationErrors.forEach((fields, index) => {
    fields.forEach((field) => {
      if(!errorsByColumnFields[field]) {
        errorsByColumnFields[field] = [];
      }
      errorsByColumnFields[field].push(index);
    })
  })
  return errorsByColumnFields;
}

export const validateBulkUploadUsers = jsonObj => {
  // let validUsers = {...jsonObj, users: [...jsonObj.users] }
  const loggedInTenant = localStorage.getItem('tenant');
  const isNotDefaultTenant = DISABLED_BULK_FOR_TENANTS.includes(loggedInTenant);

  let validUsers = JSON.parse(JSON.stringify(jsonObj))?.users;
  let counter = 0
  let invalidUsersIndex = []
  const inValidUsers = []
  const allFields = ["firstName", "firstName*", 
  "lastName", "lastName*", 
  "email", "email*", "phone", 
  "country", "locale", "sendActivationEmail", 
  "domainName", "groupIDs", "secondaryEmail", "preferredLanguage"]
  const mandatoryFields = ["firstName", "lastName", "email",]
  const asteriskFields = { "firstName*": "firstName", "lastName*": "lastName", "email*": "email" }
  const exampleTemplateUser = {
    "firstName": "exampleFirstName",
    "lastName": "exampleLastName",
    "email": "exampleEmail@email.com",
    "phone": "9999999999",
    "country": "exampleCountry",
    "locale": "exampleLocale",
    "sendActivationEmail": "trueOrFalse",
    "domainName": "exampleDomainName",
    "groupIDs": "groupId1;groupId2;groupId3",
    "secondaryEmail": "exampleEmail@email.com",
    "preferredLanguage": "exampleLanguage",
  }

  const validationErrors = [];
  const headersLength = Object.keys(jsonObj.users[0] || {}).length;
  // json object has a  "users" key, whose value is a list of user objects
  if (jsonObj.users && jsonObj.users.length > 0 ) {
    // check that attributes of jsonObj.users fits desired schema
    if (Object.keys(jsonObj.users[0]).every(field => allFields.includes(field)) && headersLength >= 3) {
      validUsers.forEach((user) => {
        // if field has an asterisk, then change to non-asterisk form
        for (const field of Object.keys(user)) {
          if (Object.keys(asteriskFields).includes(field)) { 
            user[asteriskFields[field]] = user[field]
            delete user[field];
          }
        }
        let valid = false
        if (mandatoryFields.every(field => field in user)) {
          if (_.isEqual(user, exampleTemplateUser)) {
            throw new Error(`Please remove the example user (row ${counter + EXCEL_ROW_OFFSET}) before uploading your file.`)
            return;
          } 
          if (user.sendActivationEmail === true || user.sendActivationEmail.toLowerCase() === 'true') {
            user.sendActivationEmail = true
          } else if(user.sendActivationEmail === false || user.sendActivationEmail.toLowerCase() === 'false') {
            user.sendActivationEmail = false 
          }
          if(user['groupIDs']) {
            user['groupIDs'] =user['groupIDs'].split(',').join(';')
          }
          valid = isValidName(user.firstName) 
          && isValidEmail(user.email)
          && (user.phoneNumber ? isValidPhoneNumber(user.phoneNumber) : true)
          && isValidLocale(user.locale) && isValidCountry(user.country) && isValidSecondaryEmail(user.secondaryEmail) && isValidGroupId(user.groupIDs) && isValidPreferredLanguage(user.preferredLanguage) && (isNotDefaultTenant ? isValidName(user.lastName) : true)
          addValidationErrorsForBulkUploadUser(user, validationErrors);
        }
        if (!valid) {
          invalidUsersIndex.push(counter)
          inValidUsers.push(user);
        }
      
        counter++
      })
    } else {
      throw new Error(i18next.t('bulk-upload-file-contains-incorrect-field-names'))
    }
  } else {
    throw new Error(i18next.t('bulk-upload-file-does-not-contain-any-valid-users'))
  }
  for (var i = invalidUsersIndex.length - 1; i >= 0; i--) {
    validUsers.splice(invalidUsersIndex[i], 1) // remove invalid users from jsonObj in reverse so as not to mess up index 
  }
  return ({ 
    validUsers, 
    invalidUsersIndex,
    inValidUsers, 
    validationErrors 
  })
}

export const validateReactivateUsers = (jsonObj) => {
  let validUsers = JSON.parse(JSON.stringify(jsonObj))?.users
  let counter = 0
  let invalidUsersIndex = []
  const inValidUsers = []
  const allFields = ["email", "domain"]
  const mandatoryFields = ["email", "domain"]
  const validationErrors = [];
  if (jsonObj.users && jsonObj.users.length > 0) {
    // check that attributes of jsonObj.users fits desired schema
    if (Object.keys(jsonObj.users[0]).every(field => allFields.includes(field))) {
      validUsers.forEach((user) => {
        let valid = false
        if (mandatoryFields.every(field => field in user)) {
          valid =  isValidEmail(user.email) && isValidDomainName(user.domainName)
          addValidationErrorsForReactivateUser(user, validationErrors);
        }
        if (!valid) {
          invalidUsersIndex.push(counter)
          inValidUsers.push(user);
        }
      
        counter++
      })
    } else {
      throw new Error(i18next.t('bulk-upload-reactivate-user-contains-incorrect-field-names'))
    }
  } else {
    throw new Error(i18next.t('bulk-upload-reactivate-user-file-does-not-contain-any-valid-users'))
  }
  for (var i = invalidUsersIndex.length - 1; i >= 0; i--) {
    validUsers.splice(invalidUsersIndex[i], 1) // remove invalid users from jsonObj in reverse so as not to mess up index 
  }
  return ({ 
    validUsers, 
    invalidUsersIndex,
    validationErrors,
    inValidUsers
  })
}

export const validateJson = (jsonObj, uploadType) => {
  if (uploadType === REACTIVATION_TEMPLATE.id) {
    return validateReactivateUsers(jsonObj)
  }

  return validateBulkUploadUsers(jsonObj)
}
